export const number = (value: any) => {
    if (value === undefined) {
        return 0;
    }
    const result = Number(value);
    return isNaN(result) ? 0 : result;
}

export const formatNumberWithSpaces = (value: number | string | null | undefined): string => {
    const num = number(value);
    if (isNaN(num)) {
        return '';
    }
    return num.toLocaleString("ru-RU");
};
